








































































import {Component, Prop, Watch} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay, CardForm } from '@/components/bwaff';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import _ from 'lodash';
import userManagerApi,{UserManagerApi} from '@/views/settings/multi-user-access/user-manager/api';
import workspacesApi, {WorkspacesApi} from '@/views/settings/multi-user-access/workspaces/api';
import DomainsApi from '@/services/rest/bemob/domains';
import Template from '@/views/reports/forms/traffic_sources/template.vue';
const md5 = require('md5');


@Component({
  components: {
    Template,
    FormOverlay,
    DialogForm,
    CardForm,
    ErrorAggregator,
  }
})
export default class CreateWorkspaceDialog extends Form {
  @Prop({ default: {} })
  data: any;

  userManagerApi: UserManagerApi = userManagerApi;
  workspacesApi: WorkspacesApi = workspacesApi;
  domainsApi: DomainsApi = new DomainsApi();

  show: boolean = false;
  loading: boolean = false;

  errors: any[] = [];
  errorsControlActive: boolean = false;

  workspace: any = {};

  form: any = {}; 

  rows: any = [];

  allWorkspaces: any = [];
  workspacesSearch: string = '';

  rowsOnPage: number = 10;
  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };
  oldHash: string = '';

  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  get trackingDomainsIndex() {
    let result: any = {};

    this.$store.state.cache.trackingDomains.data.forEach((item: any) => {
      result[item.id] = item;
    });

    return result;
  }

  get formTrackingDomains() {
    const trackingDomains: string[] = this.form.trackingDomains || [];
    return trackingDomains.map((id) => this.trackingDomainsIndex[id]);
  }

  set formTrackingDomains(value: any[]) {
    this.form.trackingDomains = value
      .filter((item) => item && item.id)
      .map((item) => item.id);
  }

  get searchedWorkspaces() {
    return this.workspacesSearch.trim()
      ? this.allWorkspaces.filter((workspace:any)=>{
        return workspace.name && workspace.name.toLowerCase().includes(this.workspacesSearch.toLowerCase())
      })
      : this.allWorkspaces
  }

  close() {
    this.$emit('close');
  }

  @Send(true)
  save() {
    this.loading = true;
    this.$store.commit('loading', true);

    let formToSend: any = {
      ...this.workspace,
      name:this.form.name.trim(),
      trackingDomainIds: this.form.trackingDomains
    };

    if(formToSend.type=='public'){
      formToSend = _.omit(formToSend,'memberIds');
    }

    const sendMethod = this.form.id ? 'put' : 'post';

    return this.workspacesApi[sendMethod](formToSend).then((data:any) => {
      this.close();
      const message = this.form.id ? this.t('Workspace successfully updated') : this.t('Workspace successfully added');

      /*make workspace active after create*/
      if(!this.form.id){
        this.data.setActiveWorkspace(data.id)
      }

      this.bus.emit('toast-success', message);
    }).catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        this.loading = false;
        this.$store.commit('loading', false);
        this.userManagerApi.loading = false;
      });
  }

  async mounted() {
    this.$on('error', (e: any) => {
      this.$store.commit('loading', false);
      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }

    if(this.data.workspace){
      this.workspace = this.data.workspace;
      const { trackingDomainIds = []} = this.workspace;
      const trackingDomains: any = [] ;
      trackingDomainIds.forEach((id:any)=>{
        if(this.$store.getters.cache.trackingDomainsObject[id]) {
          trackingDomains.push(this.$store.getters.cache.trackingDomainsObject[id].id)
        }
      })
      this.form = {
        ..._.omit(this.workspace,'trackingDomainIds'),
        trackingDomains
      }
    } else {
      this.form = {
        name:'',
        trackingDomains:[]
      }
    }

    this.oldHash = this.getCurrentHash()
    this.show = true;
  }
}
